import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { IdName } from './../../models/id-name.model';
import { TrainingReportSubject } from '../../enums/training-report-subject.enum';

@Pipe({
  name: 'trainingReportSubject',
  standalone: false
})
export class TrainingReportSubjectPipe implements PipeTransform {
  public transform(value: TrainingReportSubject): string {
    return getTrainingReportSubject(value);
  }
}

export function getTrainingReportSubject(value: TrainingReportSubject): string {
  switch (value) {
    case TrainingReportSubject.Employee:
      return 'Employee';
    case TrainingReportSubject.Site:
      return 'Site';
    default:
      throw new Error(`Unsupported value for TrainingReportSubject: ${value}.`);
  }
}

export function getTrainingReportSubjectList(): IdName[] {
  return enumToList(TrainingReportSubject, getTrainingReportSubject);
}
